@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

.modalBody {
  display: flex;
  width: 100%;
  max-width: 1000px;
  flex-direction: column;
  align-items: flex-start;
  background-color: var(--light-80);
  gap: 20px;
  border-radius: 20px;
  @include blur(15px);
  @media (max-width: $phoneMaxWidth) {
    background-color: var(--default-bg);
    height: 100%;
    overflow-y: auto;
    min-height: unset;
  }
}

.mobileCardContainer {
  display: flex;
  width: 115.377px;
  height: 158.414px;
  align-items: flex-start;
  gap: 5.756px;
}

.headerContainer {
  display: flex;
  padding: 12px;
  flex-direction: column;
  gap: 12px;
  text-align: start;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
}

.step {
  /* Remove the position absolute from here */
  top: 0;
  left: 0;
  width: 100%;
  transition: opacity 0.3s ease;
  visibility: hidden;
  opacity: 0;
}

.step.active {
  visibility: visible;
  opacity: 1;
  position: relative; /* Use relative positioning for the active step */
}

.step:not(.active) {
  display: none; /* Hide the non-active steps to fix excessive scroll */
}

.modalInner {
  z-index: 4;
  position: relative;
  display: flex;
  align-items: flex-start;
  padding: 70px 110px;
  height: 665px;
  width: 100%;
  justify-content: center;
  gap: 12px;
  @media (max-width: $phoneMaxWidth) {
    display: none;
  }
}

.selectContainer {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  background-color: var(--default-bg);
  padding: 20px 10px;
  position: sticky;
  z-index: 100;
  bottom: 0;
  z-index: 10;
  @media (min-width: $phoneMaxWidth) {
    flex-direction: row;
    @include blur(15px);
    background-color: var(--light-80);
    box-shadow: 0px -3px 4px 0px rgba(0, 0, 0, 0.08), 0px 2px 10px 0px rgba(0, 0, 0, 0.06);
  }
}

.desktopButtonRow {
  display: flex;
  width: 100%;
  justify-content: flex-end;
  flex-direction: row;
  gap: 16px;
}

.buttonContainer {
  position: absolute;
  top: 28px;
  left: 28px;
}

.modalHeaderContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: stretch;
  gap: 6px;

  .modalHeaderTitle {
    text-align: center;
    @media (min-width: $phoneMaxWidth) {
      text-align: start;
      padding-left: 20px;
    }
  }
}

.modalHeader {
  color: #000;
  text-align: center;
  @include xxl-robotobold;
}

.modalSubheader {
  @include md-sohne;
  color: var(--neutral-90);
  text-align: center;
  padding: 0px 10px;
  @media (min-width: $phoneMaxWidth) {
    text-align: start;
    padding-left: 20px;
  }
}

.grid {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  overflow-y: scroll;
  gap: 15px;
  padding-top: 5px;
  align-self: stretch;
  flex-wrap: wrap;
  @media (max-width: $phoneMaxWidth) {
    gap: 8px;
    padding-bottom: unset;
  }

  &.hidden {
    display: none;
  }
}

.backButton {
  width: 36px;
  height: 36px;
  @media (max-width: $phoneMaxWidth) {
    display: none;
  }
}

.whiteButton {
  background-color: white;

  &:hover {
    background-color: white;
  }
}

.welcomeContainer {
  display: flex;
  width: 494px;
  padding: 32px;
  padding-top: 48px;
  gap: 28px;
  flex-direction: column;
  align-items: flex-end;
  border-radius: 12px 0px 0px 12px;
  border-radius: 6px;
  background: var(--light-60);
  /* Container Shadow */
  box-shadow: 1px 1px 0px 0px rgba(255, 255, 255, 0.9) inset, 0px 2px 12px 0px rgba(0, 0, 0, 0.04);
  @include blur;
  @media (max-width: $phoneMaxWidth) {
    display: none;
  }

  .section {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .welcomeContainerInner {
    display: flex;
    flex-direction: column;
  }
}

.divider {
  margin: 16px 0;
  width: 100%;
  height: 1px;
  background-color: var(--dark-4);

  @media (max-width: $phoneMaxWidth) {
    margin: 0;
  }
}

.welcomeHeader {
  color: var(--neutral-90);
  @include xxl-robotobold;
}

.welcomeDescription {
  color: var(--Neutral-50, #4c566a);
  text-transform: none;
  @include xl-medium;

  @media (max-width: $phoneMaxWidth) {
    text-align: center;
  }
}

.goButton {
  background: var(--Neutral-90, #2b2f38);
}

.step1 {
  padding: 20px 0px 0px 0px;
  gap: 15px;
  display: flex;
  flex-direction: column;
}

.identityCardContainer {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mobileCardWrapper {
  @include blur(16.02454376220703px);
  display: flex;
  width: 100%;
  border-radius: 3.96px;
  box-shadow: 0.458px 0.458px 0px 0px rgba(255, 255, 255, 0.9) inset, 0px 0.916px 5.494px 0px rgba(0, 0, 0, 0.04);
  background: var(--Light-60, rgba(255, 255, 255, 0.6));
}

.cardContainer {
  width: 315px;
  height: 470px;
  display: flex;

  @include for-phone-only {
    width: 115.377px;
    height: 158.414px;
  }
}

.cardButtonsContainer {
  position: absolute;
  bottom: -44px;
  display: flex;
  gap: 8px;
  left: 50%;
  transform: translateX(-50%);
  @media (max-width: $phoneMaxWidth) {
    display: none;
  }
}

.mobileWelcomeContainer {
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: auto;
}
.mobileWelcomeContainerOuter {
  display: none;
  flex-direction: column;
  height: 100vh;
  overflow: auto;
  gap: 28px;
  padding: 24px;
  @media (max-width: $phoneMaxWidth) {
    display: flex;
  }
}

.modalWrapper {
  padding-top: 0;
  padding-bottom: 0;
  max-height: 100%;
  @media (min-width: $desktopMinWidth) {
    max-height: 100%;
    overflow-y: scroll;
  }
}

.mobileHeader {
  display: none;

  .backButton {
    align-self: flex-start;
    display: block;
  }

  @media (max-width: $phoneMaxWidth) {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 8px;
  }
}

.skipButton {
  display: none;

  @media (max-width: $phoneMaxWidth) {
    display: block;
    align-self: center;
  }
}
